(function (aimi_calendar, $, app, undefined) {
  let __this = {};

  app.apis['calendar'] = function () {
    return {
      'build': function (id) {
        return app.getRequest(`/api/calendar/build/${id}`, {}, function () {
        }, function () {
        });
      },
      buildPosts : function (requestData) {
        const id = requestData.id;
        const range = requestData.range;

        let url = `/api/calendar/${id}/build-posts?start=${range[0]}&end=${range[1]}`;
        return app.getRequest(url, {}, function () {
        }, function () {
        });
      },
      'buildNextMonth': function (id) {
        return app.getRequest(`/api/calendar/${id}/build-next-month`, {}, function () {
        }, function () {
        });
      },
      'noBuild': function (id) {
        return app.postRequest(`/api/calendar/${id}/no-build`, {}, function () {
        }, function () {
        });
      },
      'maxDate': function (id) {
        return app.getRequest(`/api/calendar/${id}/max-date`, {}, function () {
        }, function () {
        });
      },
      'update': async function (id, requestData) {
        let updateResponse = null;
        try{
          updateResponse = await app.putRequest(`/api/user/calendars/${id}`, requestData, function () {}, function (){});
        } catch(error) {
          console.log(error);
        }
        const response = await this.fetch();
        return updateResponse;
      },
      'add': function (requestData) {
        return app.postRequest(`/api/user/calendars`, requestData, function () {
        }, function () {
        });
      },
      'save': async function (requestData) {
        if (app.isEmpty(requestData.id)) {
          return this.add(requestData)
        } else {
          return this.update(requestData.id, requestData)
        }
      },
      'delete': function (id) {
        return app.deleteRequest(`/api/user/calendars/${id}`, {}, function () {
        }, function () {
        });
      },
      'fetch': async function () {
        const response = await app.getRequest(`/api/user/calendars`, {}, function () {
        }, function () {
        });
        const calendars = _.indexBy(response.result, 'id');
        app.calendar = calendars[app.calendarId];
        return calendars;
      },

      'posts': function (calendarId) {
        return app.getRequest(`/api/user/calendars/${calendarId}`, {}, function () {
        }, function () {
        });
      },
      'addPost': function (post) {
        return app.putRequest(`/api/post/full/${post.id}`, post, function () {
        }, function () {
        });
      },
      'deletePost': function (id) {
        return app.deleteRequest(`/api/post/post/${id}`, {}, function () {
        }, function () {
        });
      },
      'addCustomPost': function (requestData) {
        return app.postRequest(`/api/user/calendars/post/${requestData.calendar.id}`, requestData, function () {
        }, function () {
        });
      },
      quota: function () {
        return app.getRequest(`/api/user/calendars/check`, {}, function () {
        }, function () {
        });
      },

      scheduleAll: async function (calendarId, posts) {
        return app.postRequest(`/api/user/calendars/schedule-all/${calendarId}`, posts, function () {
        }, function () {
        });
      },

      unScheduleAll: async function (calendarId) {
        return app.getRequest(`/api/user/calendars/unschedule-all/${calendarId}`, {}, function () {
        }, function () {
        });
      },

      rebuild: async function (calendarId, partial, keepScheduled) {
        let url = `/api/calendar/${calendarId}/rebuild?partial=${partial}&keepScheduled=${keepScheduled}`;
        return app.getRequest(url, {}, function () {
        }, function () {
        });
      },

      unApprovePostsSave: function (requestData) {
         return this.approvePosts('unapprove', null, requestData);
      },

      reviewPostsSave: function (requestData) {
        return this.approvePosts('review', requestData[0].id, requestData);
      },

      approvePosts:  function (status, postId, buldPostIds = []) {
        let requestData = {
          'posts' : buldPostIds,
          'status' : status
        };

        if (status === 'approve') {
          if (postId) {
            return app.postRequest(`/api/post/approve/${postId}`, requestData, function () {
            }, function () {
            });
          } else {
            return app.postRequest(`/api/post/approve`, requestData, function () {
            }, function () {
            });
          }
        }
        if (status === 'review') {
          if (postId) {
            return app.putRequest(`/api/post/approve/${postId}`, requestData, function () {
            }, function () {
            });
          }
        }
        if (status === 'unapprove') {
          if (postId) {
            return app.deleteRequest(`/api/post/approve/${postId}`, requestData, function () {
            }, function () {
            });
          } else {
            return app.deleteRequest(`/api/post/approve`, requestData, function () {
            }, function () {
            });
          }
        }
        if (status === 'unapprove-unapproved') {
          return app.deleteRequest(`/api/post/approve`, requestData, function () {
          }, function () {
          });
        }
      }
    }
  }();

}(window.aimi_calendar = window.aimi_calendar || {}, jQuery, PreBuilt));

function approvePosts($elementsList, postId = false, status = 'approve', reason = '') {
  let appTransport = app.transport(),
      postIds = [];

  $elementsList.each(function () {
    let postObject = {'id': $(this).data('id')};
    if (status == 'unapprove' || status == 'unapprove-unapproved') {
      postObject['reason'] = reason;
    }
    if (status == 'review') {
      postObject['reason'] = reason;
    }
    postIds.push(postObject);
  });

  let requestData = {
    'posts' : postIds,
    'status' : status
  };

  appTransport
      .setEvent('onSuccess', function (response) {
        let id = __this.$lastActivePost.data('id');
        $.when(aimi_calendar.refreshCalendar()).done(function () {
          let post = __this.posts.find(row => (parseInt(row.id) === id));
          aimi_campaign_library.navigateWallToPost(post);
        });
        $('.button-approve, .button-unapprove').removeAttr('disabled');
      })
      .setEvent('onError', function (response) {
        mobiscroll.snackbar({
          message: response.message.message,
          color: 'danger'
        });
        $('.button-approve, .button-unapprove').removeAttr('disabled');
        return false;
      });

  if (status == 'approve') {
    if (postId) {
      appTransport.post('/api/post/approve/' + postId, requestData);
    } else {
      appTransport.post('/api/post/approve', requestData);
    }
  }
  if (status == 'review') {
    if (postId) {
      appTransport.put('/api/post/approve/' + postId, requestData);
    }
  }
  if (status == 'unapprove') {
    if (postId) {
      appTransport.delete('/api/post/approve/' + postId, requestData);
    } else {
      appTransport.delete('/api/post/approve', requestData);
    }
  }
  if (status == 'unapprove-unapproved') {
    appTransport.delete('/api/post/approve', requestData);
  }

}